import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// Utilities are emitted under the tw- prefix, so tailwind-merge needs the same prefix to dedupe conflicts.
const twMerge = extendTailwindMerge({ prefix: 'tw-' });

/** Joins conditional class names and resolves conflicting Tailwind utilities, last one winning. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
